import { render, staticRenderFns } from "./RevertRecoveryInfoPage.vue?vue&type=template&id=191571be&"
import script from "./RevertRecoveryInfoPage.vue?vue&type=script&lang=js&"
export * from "./RevertRecoveryInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports